import styled from 'styled-components';

export const IframeContainer = styled.iframe`
  width: 100%;
  min-height: 280px;
`;
